import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkConfig } from '@/shared/types/store';
import { resetApiCaches } from '../../lib/utils/authUtils';
import { adminActions } from '../slice/adminSlice';

export const logoutThunk = createAsyncThunk<void, void, ThunkConfig<void>>(
  'auth/logout',
  async (_, thunkAPI) => {
    const { extra, rejectWithValue } = thunkAPI;
    try {
      await extra.api.post('/admin-auth/logout');
      thunkAPI.dispatch(adminActions.logout());
      resetApiCaches();
    } catch (e) {
      thunkAPI.dispatch(adminActions.logout());
      resetApiCaches();
      return rejectWithValue();
    }
  },
);
